export enum ProductStatus {
  active = 'active',
  draft = 'draft',
  suspended = 'suspended',
  ghost = 'ghost'
}
